/*
 * This is a unified interface for getting feature flags for a user / instance.
 * The point of having this in one place is so that we can avoid checking
 * `window.NutclientConfig` and `window.` all over the web client code.
 */
export function getFeatureFlag(featureFlagName: string): boolean {
    if (typeof window === 'undefined') {
        throw new Error(`Unable to determine ${featureFlagName}, because window is undefined`);
    }

    // @ts-expect-error
    if (!window.NutClientConfig) {
        throw new Error(
            `Unable to determine ${featureFlagName}, because NutClientConfig is not found on window`
        );
    }

    // @ts-expect-error
    if (typeof window.NutClientConfig[featureFlagName] === 'undefined') {
        throw new Error(
            `Unable to determine ${featureFlagName}, because it is not in NutClientConfig`
        );
    }

    // @ts-expect-error
    return Boolean(window.NutClientConfig[featureFlagName]);
}
